import { operators as o } from '@pendo/aggregations';
import { COMMON_VOC_EVAL_VISITOR_USERNAME } from '@/voc/helpers/aggs.helper';
import { PRODUCT_AREAS, SUB_PRODUCT_AREAS } from '@/utils/aggregation';

const { VOC } = PRODUCT_AREAS || {};
const { CAPTURE } = SUB_PRODUCT_AREAS || {};

export default {
    name: 'VocItemsCreatedByAggAdditionalUsers',
    productArea: VOC,
    subProductArea: CAPTURE,
    responseFormat: 'rows',
    build: ({ type = 'feedback', visitorDisplayName = null }) => {
        const pipeline = o.pipeline(
            o.sources.vocItems({ type, appId: 'expandAppIds("*")' }),
            o.filter('createdByType == "Visitor" || createdByType == "IntegrationKey"'),
            o.join('createdById'),
            o.fork(
                o.pipeline(
                    o.filter('createdByType == "Visitor"'),
                    o.bulkExpand('createdByObj', 'visitor', 'createdById'),
                    o.evaluate('createdBy.id', 'createdById'),
                    o.evaluate('createdBy.type', '"Visitor"'),
                    ...COMMON_VOC_EVAL_VISITOR_USERNAME(visitorDisplayName, 'createdBy.username', 'createdByObj'),
                ),
                o.pipeline(
                    o.filter('createdByType == "IntegrationKey"'),
                    o.expand('createdByObj', 'integrationKey', 'createdById'),
                    o.evaluate('createdBy.id', 'createdById'),
                    o.evaluate('createdBy.type', '"IntegrationKey"'),
                    o.evaluate('createdBy.username', 'createdByObj.username'),
                ),
            ),
            o.select({
                id: 'createdById',
                username: 'createdBy.username',
                type: 'createdByType',
            }),
        );

        return pipeline;
    },
};
